const DRAFT = { id: 'DRAFT', name: 'Draf', label: 'fleetTask.status.draft' }
const SCHEDULED = { id: 'SCHEDULED', name: 'Dijadwalkan', label: 'fleetTask.status.scheduled' }
const STARTED = { id: 'STARTED', name: 'Dijalankan', label: 'fleetTask.status.started' }
const ENDED = { id: 'ENDED', name: 'Selesai', label: 'fleetTask.status.ended' }
const CANCELED = { id: 'CANCELED', name: 'Dibatalkan', label: 'fleetTask.status.canceled' }
const WAITING_FOR_VENDOR = { id: 'WAITING_FOR_VENDOR', name: 'Kirim Ke Vendor', label: 'fleetTask.status.waiting' }
const ACCEPTEP_BY_VENDOR = { id: 'ACCEPTEP_BY_VENDOR', name: 'Diterima Vendor', label: 'fleetTask.status.accepted' }
const REJECTED_BY_VENDOR = { id: 'REJECTED_BY_VENDOR', name: 'Ditolak Vendor', label: 'fleetTask.status.rejected' }
const WAITING_FOR_APPROVAL = { id: 'WAITING_FOR_APPROVAL', name: 'Kirim Persetujuan', label: 'fleetTask.status.waitingForApproval' }

const status = {
  DRAFT,
  SCHEDULED,
  STARTED,
  ENDED,
  CANCELED,
  WAITING_FOR_VENDOR,
  ACCEPTEP_BY_VENDOR,
  REJECTED_BY_VENDOR,
  WAITING_FOR_APPROVAL,
}

export const statusIdToLabelMap = {
  [DRAFT.id]: DRAFT.label,
  [SCHEDULED.id]: SCHEDULED.label,
  [STARTED.id]: STARTED.label,
  [ENDED.id]: ENDED.label,
  [CANCELED.id]: CANCELED.label,
  [WAITING_FOR_VENDOR.id]: WAITING_FOR_VENDOR.label,
  [ACCEPTEP_BY_VENDOR.id]: ACCEPTEP_BY_VENDOR.label,
  [REJECTED_BY_VENDOR.id]: REJECTED_BY_VENDOR.label,
  [WAITING_FOR_APPROVAL.id]: WAITING_FOR_APPROVAL.label,
}

export const statusNameToIdMap = {
  [DRAFT.name]: DRAFT.id,
  [SCHEDULED.name]: SCHEDULED.id,
  [STARTED.name]: STARTED.id,
  [ENDED.name]: ENDED.id,
  [CANCELED.name]: CANCELED.id,
  [WAITING_FOR_VENDOR.name]: WAITING_FOR_VENDOR.id,
  [ACCEPTEP_BY_VENDOR.name]: ACCEPTEP_BY_VENDOR.id,
  [REJECTED_BY_VENDOR.name]: REJECTED_BY_VENDOR.id,
  [WAITING_FOR_APPROVAL.name]: WAITING_FOR_APPROVAL.id,
}

export default status
